import './index.scss';
import Initializer from 'lib/initializer';

Initializer.registerComponent('site/short_author_bio', function(element, data) {
  // we'd add something here if we dynamic behaviour on the client
});
